import { render, staticRenderFns } from "./BusChangeReportDialog.vue?vue&type=template&id=5666ebe9&scoped=true&"
import script from "./BusChangeReportDialog.vue?vue&type=script&lang=js&"
export * from "./BusChangeReportDialog.vue?vue&type=script&lang=js&"
import style0 from "./BusChangeReportDialog.vue?vue&type=style&index=0&id=5666ebe9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5666ebe9",
  null
  
)

export default component.exports